module.exports = __webpack_public_path__ + "static/img/login_box.53ddd71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login_box.png
// module id = yMK/
// module chunks = 1